import React from 'react';
import { makeStyles } from 'design-system/styles';

interface NERSelectionProps {
  clientBoxes: {
    top: number;
    left: number;
    height: number;
    width: number;
  }[];
}

const NERSelection: React.FC<NERSelectionProps> = ({ clientBoxes }) => {
  const classes = useNERSelectionStyles();
  return (
    <>
      {clientBoxes.map(({ top, left, height, width }, idx) => (
        <div
          key={idx}
          className={classes.selection}
          style={{
            top,
            left,
            height,
            width,
          }}
        />
      ))}
    </>
  );
};

const useNERSelectionStyles = makeStyles({
  selection: {
    position: 'absolute',
    backgroundColor: 'rgba(0,0,0,0.05)',
  },
});

export default NERSelection;
